import { Link } from 'react-router-dom';

/**
 * NerdChem back button (was misnamed ChemHome) for chem tool pages.
 *
 * Mirrors HomeButton.jsx exactly in styling/behaviour, but routes to the
 * NerdChem suite landing (/chem) rather than the NerdStack root (/). When
 * the /stack/ migration happens this stays correct — it's suite-relative.
 */
export function ChemBackButton({ accentColor = '#F8B84E' }) {
  return (
    <Link
      to="/chem"
      aria-label="Back to NerdChem home"
      title="Back to NerdChem"
      style={{
        display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
        width: 48, height: 48, borderRadius: 14,
        border: `1.5px solid ${accentColor}66`, background: `${accentColor}24`,
        color: accentColor, textDecoration: 'none', cursor: 'pointer',
        transition: 'all 0.15s ease', flexShrink: 0,
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.background = `${accentColor}3D`;
        e.currentTarget.style.borderColor = `${accentColor}99`;
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.background = `${accentColor}24`;
        e.currentTarget.style.borderColor = `${accentColor}66`;
      }}
    >
      <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor"
        strokeWidth="3.6" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
        <path d="M19 12H5" />
        <path d="M12 19l-7-7 7-7" />
      </svg>
    </Link>
  );
}
